import axios from "axios";
import {
  BaseURL,
  BaseURLELearningService,
  CompanyID,
  EmployeeID,
} from "configs/AppConfig";
import { message } from "antd";
import axiosInstance from "auth/axiosInstance";

let LearningService = {};

LearningService.getCohorts = async function (page, pageSize, search) {
  try {
    const response = await axios({
      url: `/CohortService.svc/GetAllCohort`,
      params: {
        Size: pageSize ? pageSize : null,
        Page: page ? page : null,
        Search: search,
      },
    });
    const cohorts = response.data.Data;
    return cohorts;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getCourses = async function (CohortID) {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetAllCoursesByCohortID`,
      params: {
        EmployeeID: EmployeeID,
        CohortID: CohortID,
      },
    });
    const courses = response.data.Data;
    return courses;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getModules = async function (CohortID, CourseId) {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetModulesByCourseID`,
      params: {
        EmployeeID: EmployeeID,
        CohortID: CohortID,
        CourseID: CourseId,
      },
    });
    const modules = response.data.Data;
    return modules;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.GetAllCoursesByCompany = async function (
  page,
  search,
  pageSize,
  CourseTypeID,
  Status,
  signal,
  DepartmentIds,
) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/V2/GetAllCoursesByCompanyID`,
      params: {
        Page: page,
        Search: search,
        Size: pageSize,
        CourseTypeID: CourseTypeID == undefined ? 1 : CourseTypeID,
        Status: Status,
        // Only send DepartmentIds when it is a real non-empty string.
        // Guards against AbortSignal or undefined accidentally leaking in.
        CourseDepartments:
          typeof DepartmentIds === "string" && DepartmentIds.length > 0
            ? DepartmentIds
            : null,
      },
      signal: signal instanceof AbortSignal ? signal : undefined,
    });
    const Courses = response.data.Data;
    return Courses;
  } catch (error) {
    if (error.code === "ERR_CANCELED" || error.name === "CanceledError") {
      return null;
    }
    console.log(error);
    message.warning(error);
    return [];
  }
};

LearningService.GetAllCourseTags = async function (CourseTypeID) {
  try {
    const response = await axios({
      url: `${BaseURL}/CourseService.svc/admin/GetAllCourseTags`,
      params: {
        CourseTypeID: CourseTypeID ? CourseTypeID : CourseTypeID,
      },
      headers: {
        EmployeeID: EmployeeID,
      },
    });
    const getAll = response?.data?.Data;
    return getAll;
  } catch (error) {
    return null;
  }
};

LearningService.UpdateNewCourseTags = async function (CourseId, updateNewTag) {
  try {
    const response = await axios({
      method: "post",
      url: `${BaseURL}/CourseService.svc/admin/UpdateCourseTags`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: {
        CourseId: CourseId ? CourseId : null,
        Tags: updateNewTag,
      },
    });
    return response;
  } catch (error) {
    return null;
  }
};

LearningService.DeleteTagsFromAllCourse = async function (removeTag) {
  try {
    const response = await axios({
      method: "post",
      url: `${BaseURL}/CourseService.svc/admin/DeleteTagsFromAllCourse`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: {
        Tags: removeTag,
      },
    });
    return response;
  } catch (error) {
    return null;
  }
};

LearningService.GetAllLecturesByCourseID = async function (
  CourseID,
  conditionType,
) {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetAllLecturesByCourseID`,
      params: {
        EmployeeID: EmployeeID,
        CourseID: CourseID,
        CourseTypeID: conditionType ? 2 : 1,
      },
      // headers: Headers,
    });
    const Lectures = response.data.Data;
    return Lectures;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.addCohort = async function (cohort) {
  // console.log(cohort)
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/AddCohort`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: cohort,
      // headers: Headers,
    });

    // console.log(cohort)
    // console.log(response)

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};
// CohortService.svc/admin/CloneCoursesForLearningPath

LearningService.CloneCoursesForLearningPath = async function (cohort) {
  console.log(cohort);
  try {
    const response = await axios({
      method: "post",
      url: `CohortService.svc/admin/CloneCoursesForLearningPath`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: cohort,
      // headers: Headers,
    });

    // console.log(cohort)
    // console.log(response)

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.UpdateCohortCourseSequence = async function (cohort) {
  // console.log(cohort)
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/UpdateCohortCourseSequence`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: cohort,
      // headers: Headers,
    });

    // console.log(cohort)
    // console.log(response)

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.updateCohort = async function (cohort) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/UpdateCohort`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: cohort,
      // headers: Headers,
    });

    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.editLearners = async function (cohort) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/UpdateLearnersByCohortId`,
      params: {
        CohortID: cohort.CohortID,
      },
      data: cohort,
      // headers: Headers,
    });

    response.data.Status === 1
      ? message.success("Learner Group Updated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.addLearners = async function (cohort) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/AddLearners`,
      params: {
        CohortID: cohort.CohortID,
      },
      data: cohort,
      // headers: Headers,
    });

    response.data.Status === 1
      ? message.success("Learner Group Updated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.removeLearners = async function (cohort) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/RemoveLearners`,
      params: {
        CohortID: cohort.CohortID,
      },
      data: cohort,
      // headers: Headers,
    });

    response.data.Status === 1
      ? message.success("Learner Group Updated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.resetLearners = async function (cohort) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/ResetCourseForLearners`,
      data: cohort,
      // headers: Headers,
    });
    response.data.Status === 1
      ? message.success("Learners Resetted")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getLearners = async function (CohortId) {
  console.log("api call time", CohortId);
  try {
    const response = await axios({
      url: `/CohortService.svc/admin/GetLearnersByCohortId`,
      params: {
        CohortId: CohortId,
      },
      // headers: Headers,
    });

    const Learners = response.data.Data.EmployeeCode;
    console.log(Learners);
    return Learners;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.addCourse = async function (course, isPodcast) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/AddCourse`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: course,
      // headers: Headers,
    });

    // console.log(response)
    response.data.Status === 1
      ? isPodcast
        ? message.success("Podcast Added")
        : message.success("Course Added")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.updateCourse = async function (course) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/UpdateCourse`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: course,
      // headers: Headers,
    });

    response.data.Status === 1
      ? message.success("Course Updated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.deleteCohort = async function (cohortId) {
  const dt = {
    CohortId: cohortId,
  };
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/DeleteCohort`,
      data: dt,
      // headers: Headers,
    });

    response.data.Status === 1
      ? message.success("Learning path deleted")
      : message.error(response.data.Message);
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.deleteCourse = async function (courseId, isPodcast) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/DeleteCourseById`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: {
        CourseId: courseId,
        CourseTypeID: isPodcast ? 2 : 1,
      },
      // headers: Headers,
    });

    response.data.Status === 1
      ? isPodcast
        ? message.success("Podcast Deleted")
        : message.success("Course Deleted")
      : message.error(response.data.Message);
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getCompletedVideos = async function () {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetAllVideosCompleted`,
      params: {
        EmployeeID: EmployeeID,
      },
      // headers: Headers,
    });
    const modules = response.data.Data;
    return modules;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getCompletedModule = async function (
  CourseId,
  CohortId,
  CourseLectureId,
) {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetCompletedModules`,
      params: {
        EmployeeID: EmployeeID,
        CourseId: CourseId,
        CohortId: CohortId,
        LectureId: CourseLectureId,
      },
      // headers: Headers,
    });
    const getModule = response.data;
    return getModule;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getCompletedCourse = async function (CourseId, CohortId) {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetCompletedCourses`,
      params: {
        EmployeeID: EmployeeID,
        CourseId: CourseId,
        CohortId: CohortId,
      },
      // headers: Headers,
    });
    const getCompCourse = response.data.Data;
    return getCompCourse;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getAllModulesByCourseId = async function (id, conditionType) {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetAllLecturesByCourseID`,
      params: {
        CourseID: id,
        EmployeeID: EmployeeID,
        CourseTypeID: conditionType ? 2 : 1,
      },
    });

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.UpdateLectureSequence = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/UpdateLectureSequence`,
      data: data,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

LearningService.GetAllCohortByCourseID = async function (id, checkViewType) {
  try {
    const response = await axios({
      url: `/CohortService.svc/GetAllCohortByCourseID`,
      params: {
        CourseID: id,
        EmployeeID: EmployeeID,
        CourseTypeID: checkViewType ? 2 : 1,
      },
    });
    const getModulesByCourseId = response.data.Data;
    return getModulesByCourseId;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getCourseDetails = async function (id, checkViewType) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/GetCourseByID`,
      params: {
        CourseID: id,
        CourseTypeID: checkViewType ? 2 : 1,
        // EmployeeID: EmployeeID,
      },
    });
    const courseDetails = response.data.Data;
    // console.log(response)
    return courseDetails;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getCertificateTemplates = async function () {
  try {
    const response = await axios({
      url: `/CertificateService.svc/admin/GetAll/Templates`,
    });
    const data = response.data.Data;
    // console.log(response)
    return data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getCertificateTemplate = async function (ID) {
  try {
    const response = await axios({
      url: `/CertificateService.svc/admin/get/template/file`,
      params: {
        Id: ID,
        // EmployeeID: EmployeeID,
      },
    });
    console.log(response);
    const data = response.data;
    // console.log(response)
    return data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.updateCourseDetails = async function (objectCourse, isPodcast) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/UpdateCourseDetails`,
      // params: {
      //   EmployeeID: EmployeeID,
      // },
      data: objectCourse,
    });
    // console.log(objectCourse)
    // console.log(response)

    // response.data.Status === 1
    //   ? isPodcast
    //     ? message.success("Podcast Updated")
    //     : message.success("Course Updated")
    //   : message.warning(response.data.Message);
    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.deactivateCohort = async function (CohortId, courseId) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/CohortCourseActiveDeActive`,
      // params: {
      //   EmployeeID: EmployeeID,
      // },
      data: {
        CohortId: CohortId,
        CourseId: courseId,
        Status: 0,
      },
    });
    // console.log(objectCourse)
    // console.log(response)
    response.data.Status === 1
      ? message.success("Learner Group Deactivated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.activateCohort = async function (CohortId, courseId) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/CohortCourseActiveDeActive`,
      // params: {
      //   EmployeeID: EmployeeID,
      // },
      data: {
        CohortId: CohortId,
        CourseId: courseId,
        Status: 1,
      },
    });
    // console.log(objectCourse)
    // console.log(response)
    response.data.Status === 1
      ? message.success("Learner Group Activated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.deleteModule = async function (data, isPodcast) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/DeleteCourseLectureById`,
      data: data,
    });

    response.data.Status === 1
      ? isPodcast
        ? message.success("Episode Deleted")
        : message.success("Module Deleted")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.updateModule = async function (moduleData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/UpdateLectureDetails`,
      // params: {
      //   EmployeeID: EmployeeID,
      // },
      data: moduleData,
    });
    response.data.Status === 1
      ? message.success("Module Updated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.addModule = async function (moduleData, isPodcast) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/v2/AddCourseLectures`,
      data: moduleData,
    });
    if (response.data.Status !== 1) {
      if (response.data.Message === "trainer_assigned") {
        message.warning(
          "You already have a training planned in the chosen slot.",
        );
      } else {
        message.warning(response.data.Message);
      }
      console.log(response.data.Message);
    }
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.GetByCourses = async function () {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/GetByCourses`,

      // headers: Headers,
    });
    const CoursesResponse = response;
    return CoursesResponse;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetByCourseLeaners = async function (id, option) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/GetByCourseLearners`,
      params: {
        CourseID: id,
        Completed: option,
      },
    });
    const CoursesResponse = response;
    return CoursesResponse;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetByCourseCardsData = async function () {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/GetByCourseCardsData`,
    });
    const CoursesResponse = response;
    return CoursesResponse;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetAnylyticsModulesByCourse = async function (id) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/GetAnylyticsModulesByCourse`,
      params: {
        CourseId: id,
      },
    });
    const CoursesResponse = response;
    return CoursesResponse;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetAnylyticsModuleNotCompletedLearners = async function (
  CourseId,
  LectureId,
) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/GetAnylyticsModuleNotCompletedLearners`,
      params: {
        CourseId: CourseId,
        LectureId: LectureId,
      },
    });
    const CoursesResponse = response;
    return CoursesResponse;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetAllCoursesByCohortID = async function (id) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/GetAllCoursesByCohortID`,
      params: {
        CohortId: id,
      },
    });
    const CoursesResponse = response;
    return CoursesResponse;
  } catch (error) {
    console.log(error);
    return null;
  }
};

LearningService.GetAnalyticsByLeaners = async function (
  FromDate,
  ToDate,
  Page,
  Size,
) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/GetAnalyticsByLeaners`,
      params: {
        FromDate: FromDate,
        ToDate: ToDate,
        Page: Page,
        Size: Size,
      },
    });
    const ByLearnerResponse = response;
    return ByLearnerResponse;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

LearningService.DeleteCourse = async function (deleteId) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/LearningPath/RemoveCourseFromList`,
      data: deleteId,
    });

    response.data.Status === 1
      ? message.success(response.data.Message)
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.UpdateCohortLearningPathTitle = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/UpdateCohortLearningPathTitle`,
      data: data,
    });

    response.data.Status === 1
      ? message.success(response.data.Message)
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetByLearnerFilterListData = async function () {
  try {
    const response = await axios({
      url: "/ELearningAnalyticsService.svc/admin/GetByLearnerFilterListData",
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
LearningService.GetFilterCourseListData = async function () {
  try {
    const response = await axios({
      method: "post",
      url: "/ELearningAnalyticsService.svc/admin/GetFilterCourseListData",
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
LearningService.GetELearningAnalyticByLeanersFilteredData = async function (
  data,
) {
  try {
    const response = await axios({
      method: "post",
      url: `/ELearningAnalyticsService.svc/admin/GetELearningAnalyticByLeanersFilteredData`,
      data: data,
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetCourseEmployees = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/GetCourseEmployees`,
      data: data,
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.UpdateCourseLectureDetails = async function (
  moduleData,
  isPodcast,
) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/v2/UpdateCourseLectureDetails`,
      data: moduleData,
    });

    if (response.data.Status === 1) {
      message.success(isPodcast ? "Episode Updated" : "Module Updated");
    } else {
      if (response.data.Message === "trainer_assigned") {
        message.warning(
          "You already have a training planned in the chosen slot.",
        );
      } else {
        message.warning(response.data.Message);
      }
    }

    if (response.status !== 200) {
      message.warning(`Request failed with a status code ${response.status}`);
    }

    return response.data;
  } catch (error) {
    console.log(error);
    message.warning("An error occurred while updating the module.");
    return null;
  }
};

LearningService.AddCourseQuiz = async function (moduleData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/v2/AddCourseQuiz`,
      // params: {
      //   EmployeeID: EmployeeID,
      // },
      data: moduleData,
    });
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};
LearningService.UpdateCourseQuizCoins = async function (moduleData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/UpdateCourseQuizCoins`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: moduleData,
    });
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.UpdateCourseQuizDetils = async function (moduleData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/v2/UpdateCourseQuizDetails`,
      // params: {
      //   EmployeeID: EmployeeID,
      // },
      data: moduleData,
    });
    response.data.Status === 1
      ? message.success("Module Updated")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.GetFilterListData = async function (FromDate, ToDate) {
  try {
    const response = await axios({
      url: "/ELearningAnalyticsService.svc/admin/dashboard/GetFilterListData",
      params: {
        FromDate: FromDate,
        ToDate: ToDate,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

LearningService.Departmentwise = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `ELearningAnalyticsService.svc/admin/dashboard/Departmentwise`,
      data: data,
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};
LearningService.Storewise = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `ELearningAnalyticsService.svc/admin/dashboard/Storewise`,
      data: data,
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.Storewise = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `ELearningAnalyticsService.svc/admin/dashboard/Storewise`,
      data: data,
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};
LearningService.Coursewise = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `ELearningAnalyticsService.svc/admin/dashboard/Coursewise`,
      data: data,
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.Employeewise = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `ELearningAnalyticsService.svc/admin/dashboard/Employeewise`,
      data: data,
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.Overall = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `ELearningAnalyticsService.svc/admin/dashboard/overall`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.quizzeDelete = async function (moduleData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/delete/Quizzes`,
      data: moduleData,
    });

    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.QuizAnswers = async function (moduleData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/update/QuizAnswers`,
      // params: {
      //   EmployeeID: EmployeeID,
      // },
      data: moduleData,
    });
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.UserQuizAttemptResponseFilterList = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `CourseService.svc/admin/Get/UserQuizAttemptResponseFilterList`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.UserQuizAttemptResponseDetails = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/byassessment`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.newCreateCourse = async function (course) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/v2/AddCourse`,
      data: course,
      // headers: Headers,
    });

    // console.log(response)
    // response.data.Status === 1
    //   ? message.success("Course Added")
    //   : message.warning(response.data.Message);
    // if (response.data.Status !== 1) {
    //   message.warning(response.data.Message);
    // }
    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error.response);
    return null;
  }
};

LearningService.ByModule = async function (passData) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/bymodule`,
      data: passData,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.ByCourse = async function (passData) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/bycourse`,
      data: passData,
    });
    return response;
  } catch (error) {
    console.log(error.response.data.message);
    return null;
  }
};

LearningService.summaryOverall = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/summary/overall`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.summaryBydepartment = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/summary/bydepartment`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.summaryByStore = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/summary/bystore`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.summaryByCourse = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/summary/bycourse`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.deleteQuizAnswers = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/delete/QuizAnswers`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.add = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortLearningPathService.svc/admin/add`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.getAllLearningPath = async function (data) {
  try {
    const response = await axios({
      method: "POST",
      url: `/CohortLearningPathService.svc/admin/v2/getAllLearningPath`,
      data: data,
    });
    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.deleteLearningPathID = async function (data) {
  try {
    const response = await axios({
      method: "DELETE",
      url: `/CohortLearningPathService.svc/admin/delete?LearningPathID=${data}`,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.editLearningPathById = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortLearningPathService.svc/admin/edit`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.getAllCohortByLearningPathId = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/getAllCohortByLearningPathId`,
      data: data,
    });

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.GetAllPathCourses = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/LearningPath/GetAllCourses`,
      data: data,
    });

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.updateLearningPathCourse = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/LearningPath/AddCohortCourse`,
      data: data,
    });

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.lpAddCohort = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/AddCohort`,
      data: data,
    });

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.lpUpdateCohortCourseSequence = async function (cohort) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/LearningPath/UpdateCohortCourseSequence`,
      data: cohort,
    });
    response.data.Status !== 1 && message.error(`${response.data.Message}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getAllLearningPathTag = async function () {
  try {
    const response = await axios({
      url: `/CohortLearningPathService.svc/admin/GetAllLearningPathTags`,
    });
    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.UpdateLearningPathTags = async function (tagData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortLearningPathService.svc/admin/UpdateLearningPathTags`,
      data: tagData,
    });
    response.data.Status !== 1 && message.error(`${response.data.Message}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.DeleteTagsFromAllLearningPath = async function (
  deleteTagaData,
) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortLearningPathService.svc/admin/DeleteTagsFromAllLearningPath`,
      data: deleteTagaData,
    });
    response.data.Status !== 1 && message.error(`${response.data.Message}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.DeleteLearningPathTags = async function (singleDeleteTag) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortLearningPathService.svc/admin/DeleteLearningPathTags`,
      data: singleDeleteTag,
    });
    response.data.Status !== 1 && message.error(`${response.data.Message}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.ResetCourseForLearners = async function (id) {
  try {
    const response = await axios({
      method: "delete",
      url: `CourseService.svc/admin/InVideo/ResetCourseForLearners`,
      params: {
        CourseId: id,
      },
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.learningPathFilterData = async function (data) {
  try {
    const response = await axiosInstance({
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/filter/learningpath`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
  }
};

LearningService.GetALlNotAssignedLearnerByCourseId = async function (
  id,
  checkViewType,
) {
  try {
    const response = await axios({
      url: `CohortService.svc/admin/learner/GetAllNotAssignedLearnersByCourseID`,
      params: {
        CourseID: id,
        CourseTypeID: checkViewType ? 2 : 1,
      },
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetAssignedLearnersByCohortId = async function (
  id,
  CourseID,
  checkViewType,
) {
  try {
    const response = await axios({
      url: `CohortService.svc/admin/learner/GetAssignedLearnersByCohortId`,
      params: {
        CohortID: id,
        CourseID: CourseID,
        CourseTypeID: checkViewType ? 2 : 1,
      },
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.GetAllAssignedLearnersByLearningPathId = async function (id) {
  try {
    const response = await axios({
      url: `/CohortService.svc/admin/learner/GetAssignedLearnersByLearningPathID/${id}`,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.getAllNotAssignedLearningPathLearner = async function (id) {
  try {
    const response = await axios({
      url: `/CohortService.svc/admin/learner/GetAllNotAssignedLearnersByLearningPathID/${id}`,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.ScormUpload = async function (
  CourseId,
  MoodleCourseId,
  ScormName,
  FileName,
  filePath,
  setGetPrecentage,
) {
  try {
    const fileStream = filePath;

    const config = {
      headers: {
        "Content-Type": "application/zip",
        // "Content-Length": fileStats.size,
      },
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        setGetPrecentage(percentCompleted);
      },
    };

    const response = await axios.post(
      `CourseService.svc/admin/v2/Scorm/Upload?CourseId=${CourseId}&MoodleCourseId=${MoodleCourseId}&ScormName=${ScormName}&FileName=${FileName}&tempfileName=${filePath.name}`,
      fileStream,
      config,
    );

    return response;
  } catch (error) {
    // Handle error
    message.warning(error.message);
    return null;
  }
};

LearningService.resetLearnersPathLearners = async function (cohort) {
  try {
    const response = await axios({
      method: "post",
      url: `/CohortService.svc/admin/LearningPath/ResetForLearners`,
      data: cohort,
      // headers: Headers,
    });
    response.data.Status === 1
      ? message.success("Learners Resetted")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data.Status;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.ManageSchedule = async function (CohortId, timeDate) {
  console.log(CohortId, timeDate);
  try {
    const response = await axios({
      method: "PUT",
      url: `/CohortService.svc/admin/learner/ManageSchedule?CohortId=${CohortId}&Schedule=${timeDate}`,
    });
    console.log(response);
    return response;
  } catch (error) {
    console.log(error);
  }
};

LearningService.ManageSchedulePublishNow = async function (data) {
  try {
    const response = await axios({
      method: "POST",
      url: "CohortService.svc/admin/learner/ManageSchedule",
      data: data,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
LearningService.addclassroom = async function (moduleData) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/v2/Admin_ClassroomAdd`,
      data: moduleData,
    });
    response.data.Status === 1
      ? message.success("Module Added")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.GetUserList = async function (
  ClassroomSessionID,
  AttendanceDate,
) {
  try {
    const params = { ClassroomSessionID };
    if (AttendanceDate) {
      params.AttendanceDate = AttendanceDate;
    }
    const response = await axios({
      method: "GET",
      url: `ClassroomService.svc/admin/classroom/getEmployeelistBySeesionID`,
      params: params,
      headers: {
        EmployeeId: EmployeeID,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

LearningService.UpdateSessionStatus = async function (moduledata) {
  try {
    const response = await axios({
      method: "POST",
      url: "ClassroomService.svc/admin/classroom/updatestatus",
      data: moduledata,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
LearningService.Trackemployee = async function (moduledata) {
  try {
    const response = await axios({
      method: "POST",
      url: "CourseService.svc/TrackEmployeeLecture",
      data: moduledata,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
LearningService.UpdateAttendance = async function (moduledata) {
  try {
    const response = await axios({
      method: "POST",
      url: "ClassroomService.svc/admin/classroom/updateattendance",
      data: moduledata,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

LearningService.AdminAddCourseTrainer = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/AddCourseTrainer`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: data,
    });

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};
LearningService.AdminUpdateCourseTrainer = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/UpdateCourseTrainer`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: data,
    });

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};
LearningService.getlecturebyid = async function (lectureid) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/GetLectureById`,
      params: {
        CourseLectureId: lectureid,
      },
    });
    const courseDetails = response.data.Data;
    // console.log(response)
    return courseDetails;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getsurveyrecipient = async function (lectureid) {
  try {
    const response = await axios({
      url: `/LmsFeedbackSurveyService.svc/admin/GetSurveyRecipientByCourseLectureId`,
      params: {
        CourseLectureId: lectureid,
      },
    });
    const Details = response.data.Data;
    // console.log(response)
    return Details;
  } catch (error) {
    console.log(error);

    return null;
  }
};

LearningService.updatesurveyrecipient = async function (Data) {
  try {
    const response = await axios({
      method: "POST",
      url: `/LmsFeedbackSurveyService.svc/admin/UpdateRecipients`,
      data: Data,
    });
    const Details = response;
    // console.log(response)
    return Details;
  } catch (error) {
    console.log(error);

    return null;
  }
};
LearningService.Admin_GetELearningAnalyticByFeedback = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/ELearningAnalyticsService.svc/admin/analytics/feedback`,
      data: data,
      headers: {
        EmployeeID: EmployeeID,
      },
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.AdminMISReportGetAssignedLearnersByCoursetId = async function (
  misdata,
) {
  try {
    const response = await axios({
      method: "POST",
      url: `/MisGoodiesService.svc/admin/misreport/learner/GetAllAssignedLearnersByCourseId`,
      data: misdata,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.AdminUpdateMis_Goodies = async function (reportdata) {
  try {
    const response = await axios({
      method: "POST",
      url: `/MisGoodiesService.svc/admin/misreport/learner/UpdateMisGoodies`,
      data: reportdata,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.CancleCourse = async function (reportdata) {
  try {
    const response = await axios({
      method: "POST",
      url: `/CourseService.svc/admin/PCV/CancelCourse`,
      data: reportdata,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};
LearningService.Mark_Batchcompleted = async function (reportdata) {
  try {
    const response = await axios({
      method: "POST",
      url: `/CourseService.svc/admin/PCV/AdminBatchCompleted`,
      data: reportdata,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.getProgramDetailsReport = async function (objectdata) {
  try {
    const response = await axios({
      method: "POST",
      url: `/MisGoodiesService.svc/admin/misreport/AdminMISProgramDetails_Report`,
      data: objectdata,
    });
    const ReportDetails = response.data.Data;
    return ReportDetails;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.getParticipantReport = async function (objectdata) {
  try {
    const response = await axios({
      method: "POST",
      url: `/MisGoodiesService.svc/admin/misreport/AdminMISParticipant_Report`,
      data: objectdata,
    });
    const ReportDetails = response.data.Data;

    return ReportDetails;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.GetNominatedUserList = async function (courseData) {
  try {
    const response = await axios({
      method: "POST",
      url: `/CourseService.svc/admin/nominatedusers/GetAllNominatedUsersByID`,
      data: courseData,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.GetAllNotAssignedUsersForNominatedCourse = async function (
  id,
  checkViewType,
) {
  try {
    const response = await axios({
      url: `CourseService.svc/admin/users/GetAllNotAssignedUsersForNominatedCourseByCourseID`,
      params: {
        CourseID: id,
        CourseTypeID: checkViewType ? 2 : 1,
      },
    });
    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

LearningService.GetAllGroupByNominatedCourseID = async function (id) {
  try {
    const response = await axios({
      url: `/CourseService.svc/GetAllGroupByNominatedCourseID`,
      params: {
        NominatedCourseID: id,
        EmployeeID: EmployeeID,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.AssignUsers = async function (group) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/AssignUsersForNomination`,
      data: group,
    });

    response.data.Status === 1
      ? message.success("Users are been assigned")
      : message.warning(response.data.Message);
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};

LearningService.ManageSchedulePublishNominationCourse = async function (data) {
  try {
    const response = await axios({
      method: "POST",
      url: "CourseService.svc/admin/users/ManageScheduleForNominatedCourse",
      data: data,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

LearningService.GetAllBatchEmployees = async function (id, checkViewType) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/nominatedcourse/GetAllBatchEmployees`,
      params: {
        CourseID: id,
        CourseTypeID: checkViewType,
      },
      headers: { EmployeeID: EmployeeID },
    });
    const getEditEmp = response.data.Data;
    return getEditEmp;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

LearningService.CheckSeatingcapacityLearnerGroup = async function (id) {
  try {
    const response = await axios({
      url: `/CohortService.svc/CheckSeatingcapacityLearnerGroup`,
      params: {
        CourseId: id,
        EmployeeId: EmployeeID,
      },
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.GetUserRoleAccessForLMS = async function () {
  try {
    const response = await axios({
      url: `CourseService.svc/admin/lms/getUserRoleAccess`,
      headers: { EmployeeID: EmployeeID, CompanyId: CompanyID },
    });
    const res = response.data.Data;
    return res;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

LearningService.GetLMSTaskRequests = async function (filter) {
  try {
    const response = await axios({
      url: `CourseService.svc/GetLMSTaskRequests`,
      params: { CompanyId: CompanyID },
      data: filter,
    });
    const res = response.data;
    return res;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

LearningService.GetLMSTaskHistory = async function (filter) {
  try {
    const response = await axios({
      url: `CourseService.svc/GetLMSTaskHistory`,
      params: { CompanyId: CompanyID },
      data: filter,
    });
    const res = response.data;
    return res;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

LearningService.GetLMSRequestNotifications = async function () {
  try {
    const response = await axios({
      url: `CourseService.svc/GetLMSRequestNotifications`,
      params: { CompanyId: CompanyID },
    });
    const res = response.data.Data;
    return res;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

LearningService.ApproveRejectLMSRequest = async function (request) {
  try {
    const response = await axios({
      method: "POST",
      url: `${BaseURL}/CourseService.svc/ApproveRejectProgramCoordinatorRequest`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: request,
    });
    return response;
  } catch (error) {
    return null;
  }
};

LearningService.UpdateRequestNotifications = async function (request) {
  try {
    const response = await axios({
      method: "POST",
      url: `${BaseURL}/CourseService.svc/UpdateRequestNotifications`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: request,
    });
    return response;
  } catch (error) {
    return null;
  }
};

LearningService.DownloadZipFile = async function (passData) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/bymodule/lmsFileUpload/Zip`,
      data: passData,
      responseType: "arraybuffer",
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};
LearningService.GetActivityResponseFileUpload = async function (payload) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/analytics/activity/report/fileupload`,
      method: "post",
      data: payload,
    });
    const courseDetails = response?.data;

    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.GetActivityResponseMetric = async function (payload) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/analytics/activity/report/metricupload`,
      method: "post",
      data: payload,
    });
    const courseDetails = response?.data;

    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};

LearningService.addAssignment = async function (assignment) {
  console.log(assignment);
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/add`,
      data: assignment,
      // headers: Headers,
    });

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.updateAssignment = async function (assignment) {
  console.log(assignment);
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/update`,
      data: assignment,
      // headers: Headers,
    });

    // console.log(cohort)
    console.log("response", response);

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.getActivityAssignments = async function (courseid, lectureid) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/activity/assignment/getall`,
      params: {
        CourseID: courseid,
        CourseLectureID: lectureid,
      },
    });
    const courseDetails = response.data.Data;
    console.log(response);
    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.DeleteAssignment = async function (fileuploadID) {
  try {
    const response = await axios({
      method: "DELETE",
      url: `${BaseURL}/CourseService.svc/admin/activity/assignment/delete/${fileuploadID}`,
    });
    return response;
  } catch (error) {
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.uploademptarget = async function (payload) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/upload/targets`,
      data: payload,
      // headers: Headers,
    });

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.uploadmaxfileuploadlimit = async function (payload) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/update/settings`,
      data: payload,
      // headers: Headers,
    });

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.getActivityDetails = async function (courseid, lectureid) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/activity/assignment/settings/GetDetails`,
      params: {
        CourseID: courseid,
        CourseLectureID: lectureid,
      },
    });
    const courseDetails = response?.data;

    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.CheckActivityModuleIncomplete = async function (
  courseid,
  lectureid,
) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/activity/CheckActivityModuleIncomplete`,
      params: {
        CourseID: courseid,
        CourseLectureID: lectureid,
      },
    });
    const courseDetails = response.data.Data;
    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.GetAllUserFileDetail = async function (payload) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/analytics/activity/report/fileupload/zip/downloadall`,
      method: "post",
      data: payload,
    });
    const courseDetails = response?.data;

    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.DownloadAll = async function (payload) {
  try {
    // Read auth values fresh from localStorage each time to avoid stale-token 401s
    const bearerToken = localStorage.getItem("bearerToken");
    const tenantId = localStorage.getItem("CompanyID");
    const employeeId = localStorage.getItem("EmployeeID");

    const response = await axios({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/bymodule/lmsFileUpload/Zip/downloadall`,
      data: payload,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        Accept: "application/json",
        "Accrue-Client": "AdminPanel",
        "Tenant-Id": tenantId,
        companyId: tenantId,
        EmployeeID: employeeId,
      },
    });

    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};

LearningService.addAssignment = async function (assignment) {
  console.log(assignment);
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/add`,
      data: assignment,
      // headers: Headers,
    });

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.updateAssignment = async function (assignment) {
  console.log(assignment);
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/update`,
      data: assignment,
      // headers: Headers,
    });

    // console.log(cohort)
    console.log("response", response);

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.getActivityAssignments = async function (courseid, lectureid) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/activity/assignment/getall`,
      params: {
        CourseID: courseid,
        CourseLectureID: lectureid,
      },
    });
    const courseDetails = response.data.Data;
    console.log(response);
    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.DeleteAssignment = async function (fileuploadID) {
  try {
    const response = await axios({
      method: "DELETE",
      url: `${BaseURL}/CourseService.svc/admin/activity/assignment/delete/${fileuploadID}`,
    });
    return response;
  } catch (error) {
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.uploademptarget = async function (payload) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/upload/targets`,
      data: payload,
      // headers: Headers,
    });

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.uploadmaxfileuploadlimit = async function (payload) {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/admin/activity/assignment/update/settings`,
      data: payload,
      // headers: Headers,
    });

    response.data.Status !== 1 && message.error(`${response.data.Message}`);

    // response.status !== 200 &&
    //   message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.GetActivityResponseFileUpload = async function (payload) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/analytics/activity/report/fileupload`,
      method: "post",
      data: payload,
    });
    const courseDetails = response?.data;

    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.GetAllUserFileDetail = async function (payload) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/analytics/activity/report/fileupload/zip/downloadall`,
      method: "post",
      data: payload,
    });
    const courseDetails = response?.data;

    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};
LearningService.DownloadAll = async function (payload) {
  try {
    // Read auth values fresh from localStorage each time to avoid stale-token 401s
    const bearerToken = localStorage.getItem("bearerToken");
    const tenantId = localStorage.getItem("CompanyID");
    const employeeId = localStorage.getItem("EmployeeID");

    const response = await axios({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/bymodule/lmsFileUpload/Zip/downloadall`,
      data: payload,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        Accept: "application/json",
        "Accrue-Client": "AdminPanel",
        "Tenant-Id": tenantId,
        companyId: tenantId,
        EmployeeID: employeeId,
      },
    });

    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};

LearningService.GetActivityResponseMetric = async function (payload) {
  try {
    const response = await axios({
      url: `/ELearningAnalyticsService.svc/admin/analytics/activity/report/metricupload`,
      method: "post",
      data: payload,
    });
    const courseDetails = response?.data;

    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};

LearningService.CheckActivityModuleIncomplete = async function (
  courseid,
  lectureid,
) {
  try {
    const response = await axios({
      url: `/CourseService.svc/admin/activity/CheckActivityModuleIncomplete`,
      params: {
        CourseID: courseid,
        CourseLectureID: lectureid,
      },
    });
    const courseDetails = response.data.Data;
    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};

LearningService.ImportOfflineAssessment = async function (payload) {
  try {
    const response = await axios({
      url: `/CourseService.svc/lms/offlineassessment`,
      method: "post",
      data: payload,
    });
    const courseDetails = response?.data;
    return courseDetails;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};

LearningService.ExportAssessmentReport = async function (payload) {
  try {
    const response = await axios({
      url: `/CourseService.svc/lms/courseassessment/assessmentexport`,
      method: "post",
      data: payload,
      responseType: "blob",
    });

    return response;
  } catch (error) {
    console.log(error);
    message.error("Something went wrong...");
    return null;
  }
};

LearningService.AssessmentFileDownload = async function (
  CourseTitle,
  CourseLectureName,
  EmployeeID,
) {
  const tenantId = localStorage.getItem("CompanyID");

  const response = await axios({
    method: "GET",
    url: `/CourseService.svc/lms/courseassessment/downloadpdf?CourseTitle=${encodeURIComponent(
      CourseTitle,
    )}&CourseLectureName=${encodeURIComponent(
      CourseLectureName,
    )}&EmployeeId=${EmployeeID}`,
    headers: {
      "Tenant-Id": tenantId,
    },
    responseType: "blob",
  });
  return response;
};

LearningService.summaryByEmployee = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/summary/byemployee`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.ByEmployee = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/byemployee`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.ScormUploadV2 = async function (
  file,
  courseId,
  courseLectureId,
  title,
  onUploadProgress = null,
) {
  try {
    const formData = new FormData();

    // Appending order now works seamlessly
    formData.append("file", file, file.name);
    formData.append("title", title);
    formData.append("courseId", courseId);
    formData.append("courseLectureId", courseLectureId);

    const response = await axios.post(
      "/LmsScormExternalService.svc/api/scorm/upload",
      formData,
      {
        headers: {
          companyId: CompanyID,
          // Optional: You can also pass metadata in headers if ever needed as a secondary fallback:
          // title: title,
          // courseId: courseId,
          // courseLectureId: courseLectureId,
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        onUploadProgress,
      },
    );

    return response.data;
  } catch (error) {
    console.error("SCORM upload failed:", error);
    throw error;
  }
};

LearningService.UpdateScormV2 = async function (
  file,
  courseId,
  courseLectureId,
  title,
  lectureUrl,
  scormId,
  onUploadProgress = null,
) {
  try {
    const formData = new FormData();

    // Appending order now works seamlessly
    formData.append("file", file, file.name);
    formData.append("title", title);
    formData.append("courseId", courseId);
    formData.append("courseLectureId", courseLectureId);
    formData.append("lectureUrl", lectureUrl);
    formData.append("scormId", scormId);

    const response = await axios.post(
      "/LmsScormExternalService.svc/api/scorm/update",
      formData,
      {
        headers: {
          companyId: CompanyID,
          // Optional: You can also pass metadata in headers if ever needed as a secondary fallback:
          // title: title,
          // courseId: courseId,
          // courseLectureId: courseLectureId,
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        onUploadProgress,
      },
    );

    return response.data;
  } catch (error) {
    console.error("SCORM upload failed:", error);
    throw error;
  }
};

LearningService.StoreMetadata = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURL}/LmsScormExternalService.svc/api/scorm/store-metadata`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};
LearningService.AddCourseCostDetails = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURL}/CourseService.svc/AddCourseCostDetails`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

// LearningService.uploadZipToJavaServiceWithFetch = async (
//   file,
//   courseId,
//   tenantId,
// ) => {
//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("BaseFolder", "scorm");
//   formData.append("CourseId", courseId);

//   try {
//     const response = await axiosInstance.post(
//       "http://localhost:8080/v1/s3/storage/scorm/upload",
//       formData,
//       {
//         headers: {
//           "Tenant-Id": tenantId,
//         },
//       },
//     );

//     const data = response.data;
//     if (data.Status === "1") {
//       console.log("Upload successful!", data);
//       return data;
//     } else {
//       throw new Error(data.Message || "Java upload failed.");
//     }
//   } catch (error) {
//     console.error("Error uploading to Java service:", error);
//     throw error;
//   }
// };

LearningService.EditCourseCostDetails = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURL}/CourseService.svc/EditCourseCostDetails`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error?.message || "An error occurred");
    return null;
  }
};
LearningService.GetCourseCostDetails = async function (courseid) {
  try {
    const response = await axiosInstance({
      method: "Get",
      url: `${BaseURL}/CourseService.svc/lms/coursecost`,
      params: {
        CourseId: courseid,
      },
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};
LearningService.CloneScormModule = async function (
  parentCourseId,
  childCourseId,
) {
  try {
    const response = await axios({
      method: "post",
      url: `${BaseURL}/LmsScormExternalService.svc/api/scorm/clone`,
      params: {
        parentCourseId: parentCourseId,
        childCourseId: childCourseId,
      },
      // headers: Headers,
    });

    // console.log(response)
    // response.data.Status === 1
    //   ? message.success("Course Added")
    //   : message.warning(response.data.Message);
    if (response.data.Status !== 1) {
      message.warning(response.data.Message);
    }
    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    return response;
  } catch (error) {
    console.log(error.response);
    return null;
  }
};

LearningService.summaryByEmployee = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/summary/byemployee`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

LearningService.ByEmployee = async function (data) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURLELearningService}/v1/elearning/admin/dashboard/byemployee`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};
LearningService.GetAllTrainingVenue = async function (Location = null) {
  try {
    const employeeId = localStorage.getItem("EmployeeID");
    const response = await axios({
      method: "GET",
      url: `${BaseURL}/CourseService.svc/GetAllTraingVenue`,
      params: {
        Location: Location,
      },
      headers: { EmployeeID: employeeId },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

LearningService.GetAllLectureType = async function () {
  try {
    const response = await axios({
      method: "post",
      url: `/CourseService.svc/GetAllLectureType`,
      params: {
        EmployeeID: EmployeeID,
      },
    });

    return response.data;
  } catch (error) {
    console.log(error);
    message.warning(
      error?.response?.data?.Message || error.message || "Something went wrong",
    );
    return null;
  }
};

LearningService.MISReport = async function (passData) {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${BaseURL}/ELearningAnalyticsService.svc/admin/analytics/mis/report/bycourse`,
      data: passData,
    });
    return response;
  } catch (error) {
    console.log(error.response.data.message);
    return null;
  }
};

LearningService.GetClassResponseReportData = async function (data) {
  try {
    const response = await axios({
      method: "post",
      url: `/ClassroomService.svc/admin/analytics/GetReportData`,
      data: data,
      headers: {
        EmployeeID: EmployeeID,
      },
    });

    return response;
  } catch (error) {
    message.warning(error);
    // AuthService.statusHandler(status)
    return null;
  }
};

// for syrma
LearningService.getCertificateTemplatebyID = async function (ID) {
  try {
    const response = await axios({
      url: `/CertificateService.svc/admin/get/template/file`,
      method: "GET",
      params: {
        Id: ID,
      },
      responseType: "blob",
    });

    console.log("PDF response:", response);

    return response.data;
  } catch (error) {
    console.log(error);
    message.warning("Unable to get certificate template.");
    return null;
  }
};

LearningService.getScheduleDetails = async function (
  courseId,
  courseLectureId,
) {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `${BaseURL}/ClassroomService.svc/admin/classroom/GetGetScheduleDetails`,
      params: {
        CourseId: courseId,
        CourselectureID: courseLectureId,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return error?.response || null;
  }
};

LearningService.rescheduleClassroomSession = async function (data) {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `${BaseURL}/ClassroomService.svc/admin/classroom/RescheduleSession`,
      data: data,
    });
    return response;
  } catch (error) {
    console.log(error);
    return error?.response || null;
  }
};
export default LearningService;
